import React, { Component } from 'react'
import { connect } from 'react-redux'
import { IntToSpacedDelimitedString } from '../../engine/Rules'
import { Conditionnal, InfoBulle } from '../ImportAll'
import './Bloc.css'

class BlocResultatCapaciteMaxEmprunt extends Component {
    render() {
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            const style = {}
            style.top = '-20px'
            infobulle = (
                <div className="infoBulleContainer" style={style}>
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        var montantEmpruntable = '0'
        var montantAchat = '0'
        var mensualite = '0'
        var dureeAns = '0'
        var dureeMois = '0'

        var contentPtz = undefined
        var premierPhase = 'Vous pouvez emprunter jusqu’à'

        let resultat = this.props.resultat_evaluation_max_empruntable
        if (resultat) {
            montantEmpruntable = IntToSpacedDelimitedString(
                Math.round(resultat['montant-empruntable'] / 100),
                ' '
            )

            montantAchat = IntToSpacedDelimitedString(
                Math.round(resultat['montant-achat'] / 100),
                ' '
            )
            mensualite = IntToSpacedDelimitedString(
                Math.floor(resultat.mensualite / 100),
                ' '
            )

            dureeMois = resultat.duree
            dureeAns = Math.round(dureeMois / 12)

            if (
                resultat['ptz'] !== null &&
                resultat['montant-empruntable-ptz'] !== null &&
                resultat['montant-achat-ptz'] !== null
            ) {
                var ptz = resultat['ptz']
                var ptz_montant = ptz.montant / 100
                var ptz_amortissement = ptz.amortissement / 12
                var ptz_differe = ptz.differe / 12
                var ptz_duree = ptz.duree / 12
                var montantEmpruntablePTZ = IntToSpacedDelimitedString(
                    Math.round(resultat['montant-empruntable-ptz'] / 100),
                    ' '
                )

                var text_zone_util =
                    "Il s'agit d'une estimation basée sur une zone ptz B1 (varie selon la commune du projet)."
                if (
                    this.props.ville_precise_zone &&
                    this.props.ville_precise_zone.ptz
                ) {
                    text_zone_util =
                        'Basé sur la zone PTZ ' +
                        this.props.ville_precise_zone.ptz +
                        ' de la ville selectionné (' +
                        this.props.ville_precise_zone.name +
                        ').'
                }
                var montantAchatPTZ = IntToSpacedDelimitedString(
                    Math.round(resultat['montant-achat-ptz'] / 100),
                    ' '
                )
                premierPhase =
                    'Si vous choisissez un bien dans une zone non éligible, vous pouvez emprunter jusqu’à'
                contentPtz = (
                    <div className="encart-ptz">
                        <div className="titleptz bold-font size16">
                            Vous êtes éligible au prêt à taux zéro
                        </div>
                        <div className="subtitle size11">
                            <Conditionnal
                                linked_data_id="prj_type"
                                isEqualTo
                                targetDataValueCompare="LOGEMENT_ANCIEN"
                            >
                                L'achat d'un logement ancien peut vous donner
                                droit à un prêt à taux zéro (PTZ) lorsque la
                                valeur des travaux est supérieure à 25% du
                                montant total.
                            </Conditionnal>
                        </div>

                        <div className="subtitle size11">
                            Vous pouvez emprunter jusqu’à
                        </div>
                        <div className="value size26 bold-font">
                            {montantEmpruntablePTZ} €
                        </div>

                        <div className="subtitle size11">
                            Dont{' '}
                            <b>
                                {IntToSpacedDelimitedString(ptz_montant, ' ')} €
                            </b>{' '}
                            de prêt à taux zéro sur <b>{ptz_duree} ans</b> (
                            <b>{ptz_differe} ans</b> de differé et{' '}
                            <b>{ptz_amortissement} ans</b> d'amortissement).{' '}
                            <br></br>
                            {text_zone_util}
                        </div>

                        <div className="subtitle size11">
                            Cela correspond à <b>un projet immobilier F.A.I </b>
                            (frais d’agence inclus) de
                        </div>

                        <div className="value size26 bold-font">
                            {montantAchatPTZ} €
                        </div>
                    </div>
                )
            }
        }

        return (
            <div>
                <div className="Bloc fade-in bloc-full BlocResultatCapaciteMaxEmprunt">
                    <div className="title size14 bold-font">
                        Votre capacité d'emprunt
                    </div>

                    {contentPtz}

                    <div className="subtitle size11">{premierPhase}</div>
                    <div className="value size26 bold-font">
                        {montantEmpruntable} €
                    </div>
                    <div className="subtitle size11">
                        <Conditionnal
                            linked_data_id="tech_source_neuf"
                            isEqualTo
                            targetDataValueCompare={true}
                        >
                            Cela correspond à un bien affiché en agence de
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="tech_source_neuf"
                            isNotEqualTo
                            targetDataValueCompare={true}
                        >
                            Cela correspond à <b>un projet immobilier F.A.I </b>
                            (frais d’agence inclus) de
                        </Conditionnal>
                    </div>

                    <div className="value size26 bold-font">
                        {montantAchat} €
                    </div>
                    <div className="mensualite size18 bold-font">
                        {mensualite} € / mois {infobulle}
                    </div>
                    <div className="legend size11">
                        pendant {dureeAns} ans ({dureeMois} mois)
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        resultat_evaluation_max_empruntable:
            state.answer.resultat_evaluation_max_empruntable,
        ville_precise_zone: state.answer.prj_localisation_ville,
    }
}

export default connect(mapStateToProps)(BlocResultatCapaciteMaxEmprunt)
